module.exports = __webpack_public_path__ + "static/hanson-logo-c71149b7694b4087555781e3665755ce.png";